<script setup lang="ts">
import { mergeDefaults as __MACROS_mergeDefaults } from "vue";
import { languages } from "~/utils/languages"

defineProps(__MACROS_mergeDefaults({
  code: null,
  language: null,
  filename: null,
  highlights: null,
  meta: null
}, { code: "", }))
const { copyTextToClipboard } = useClipboard()

const languageName = computed(() => {
  if (!__props.language)
    return "Plain Text"
  if (__props.language in languages)
    return languages[__props.language]
  return __props.language
})
</script>

<template>
  <section class="pre-container group">
    <pre :class="$props.class">
      <slot />
    </pre>
    <div class="actions">
      <div class="language">
        {{ languageName }}
      </div>
      <div class="copy-button" @click="copyTextToClipboard(code)">
        <icon-property
          type="copy"
          size="xs"
          class="copy-icon"
        />
      </div>
    </div>
  </section>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.pre-container
  @apply relative my-2

pre
  @apply p-4 bg-[#{$global-steel-accent}] overflow-x-auto flex
  @apply mx-0 rounded-[#{$global-br-sm}]
  @apply text-[#{$global-fs-base}]

.actions
  @apply flex items-center justify-between h-[22px]

.copy-button
  @apply cursor-pointer
  &:hover
    .copy-icon
      @apply text-[#{$global-bg-icon-primary}]
.copy-icon
  @apply text-[#{$global-bg-icon-secondary}]

.language
  @apply font-mono t-menu-sm text-[#{$global-t-tertiary}]
</style>
